// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"search_visuallyHidden_1vW4A","input":"search_input_3xqt0"};